import NAME from "./constants";

export const getTime = store => store[NAME].time;